module.exports = __webpack_public_path__ + "static/media/03_quote_desktop.a0b7efaf.jpg";